import { render, staticRenderFns } from "./digitalCertificate.vue?vue&type=template&id=17a2cde0&scoped=true&"
import script from "./digitalCertificate.vue?vue&type=script&lang=js&"
export * from "./digitalCertificate.vue?vue&type=script&lang=js&"
import style0 from "./digitalCertificate.vue?vue&type=style&index=0&id=17a2cde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a2cde0",
  null
  
)

export default component.exports